import { db } from '../firebase/config'
import { client } from '../hooks/Client'

// look up persona name
  const getPersonaName = async (personaID) => {
    const snap = await db
      .collection('Personas')
      .where('CompagnyID', '==', client)
      .where('ID', '==', personaID)
      .get()
    if (snap.empty) return 'Unknown Persona'
    return snap.docs[0].data().Name
  }

  export default getPersonaName;